export { default as AuthenticationResultFragment } from './AuthenticationResultFragment';
export { default as UserAllDataFragment } from './UserAllDataFragment';
export { default as AdminProductCategoryAllDataFragment } from './AdminProductCategoryAllDataFragment';
export { default as ShippingMethodAllFragment } from './ShippingMethodAllFragment';
export { default as PaymentMethodFragment } from './PaymentMethodFragment';
export { default as AdminBannerAllData } from './AdminBannerAllData';
export { default as AdminPromotionCategoryAllData } from './AdminPromotionCategoryAllData';
export { default as AdminProductListItem } from './AdminProductListItem';
export { default as ProductAllData } from './ProductAllData';
export { default as AdminCmsListItem } from './AdminCmsListItem';
export { default as AdminCmsAllData } from './AdminCmsAllData';
export { default as ProductAttributeListItem } from './ProductAttributeListItem';
export { default as ProductAttributeAllData } from './ProductAttributeAllData';
export { default as ProductAttributeOptionAllData } from './ProductAttributeOptionAllData';
export { default as TimetableTimeSlotAllData } from './TimetableTimeSlotAllData';
export { default as UrlAliasAllData } from './UrlAliasAllData';
export { default as ProductImageAllData } from './ProductImageAllData';
export { default as OrderListItem } from './OrderListItem';
export { default as AdminDonationItem } from './AdminDonationItem';
export { default as OrderAllData } from './OrderAllData';
export { default as UserBillingAddressFragment } from './UserBillingAddressFragment';
export { default as UserShippingAddressFragment } from './UserShippingAddressFragment';
export { default as UserDetailsFragment } from './UserDetailsFragment';
export { default as CouponListItem } from './CouponListItem';
export { default as CouponCodeAllData } from './CouponCodeAllData';
export { default as PaginatorInfoFragment } from './PaginatorInfoFragment';
export { default as UserProductDiscountFragment } from './UserProductDiscountFragment';
export { default as UserShippingDiscountFragment } from './UserShippingDiscountFragment';
export { default as OrderUpdateLogOriginal } from './OrderUpdateLogOriginal';



// WEBPACK FOOTER //
// ./src/api/graphql/fragments/index.ts